import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { MatMenuTrigger, MenuPositionX, MenuPositionY } from "@angular/material/menu";

@Component({
    selector: "ngx-mat-popover",
    templateUrl: "./ngx-mat-popover.component.html",
    styleUrls: ["./ngx-mat-popover.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: "ngxMatPopover",
    standalone: false
})
export class NgxMatPopoverComponent implements OnInit {
  @Input()
  xPosition: MenuPositionX = "after";

  @Input()
  yPosition: MenuPositionY = "below";

  @Input()
  popoverContent!: TemplateRef<unknown>;

  @Input()
  mode: "toggle" | "hover" = "toggle";

  @ViewChild(MatMenuTrigger, { static: true })
  private readonly matMenuTrigger!: MatMenuTrigger;

  constructor(private readonly elementRef: ElementRef) { }

  ngOnInit(): void {
    if (this.mode === "toggle") {
      this.elementRef.nativeElement.addEventListener("click", () => {
        this.matMenuTrigger.toggleMenu()
      }
      );
    } else {
      this.elementRef.nativeElement.addEventListener("mouseenter", () =>
        this.matMenuTrigger.openMenu()
      );
      this.elementRef.nativeElement.addEventListener("mouseleave", () =>
        this.matMenuTrigger.closeMenu()
      );
    }
  }

  open(): void {
    this.matMenuTrigger.openMenu();
  }

  close(): void {
    this.matMenuTrigger.closeMenu();
  }
}
